import { isPropsEqual } from "@fullcalendar/react";
import React from "react";
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import {Tab} from  "react-bootstrap";






const StepSix = (props) => {


   const handleChange = (event) => {
        props.setIban(event.target.value)
      

   }
   
   const handleDescription = (event) => {

     console.log("descrizione iban",event.target.value)
     props.setibanInfo(event.target.value)
   }


   return (
      <section>
          	
              <div className="col-lg-4 mb-2">
               <div className="form-group mb-3">
                  <label className="text-label">IBAN</label>
                  <span className="text-danger">*</span>
                  <input
                     type="text"
                     name="Nome"
                     className="form-control"
                     placeholder="Inserisci IBAN"
                     required
                     value={props.iban}
                     onChange={handleChange}

                    
                  />
                  <b>
                     {props.errors.iban && <div className="error">{props.errors.iban}</div>}
                  </b>
               
               </div>
            </div>
					
								<div className="my-post-content pt-3">
									<div className="post-input">
                                        <label className="text-label">Descrizione IBAN</label>
										<textarea
											name="noteBestHouse"
											id="textarea"
											rows={7} className="form-control bg-transparent" placeholder="Inserisci Causale, Beneficiario, BIC, etc.. andando a capo per ogni informazione che hai inserito"
                                            required
                                            value={props.ibanInfo}
											onChange={handleDescription}
                                 required
										/>
                              <b>
                     {props.errors.ibanInfo && <div className="error">{props.errors.ibanInfo}</div>}
                  </b>
									</div>
								</div>
							
      </section>
        
   );
};

export default StepSix;
